import { cssTransition, toast, type ToastPosition } from "react-toastify";
import { isTest } from "../IsTest";

//todo add linting rule to only allow these toast functions to speedup tests
// 1000ms in tests was short enough for a toast to appear and vanish between two `toBeVisible()` polls under load
const autoClose = isTest ? 1500 : 3000;
const transition = isTest
  ? cssTransition({
      enter: "noop",
      exit: "noop",
      collapse: false,
    })
  : undefined;

export const showSuccessNotification = (message: string) => {
  toast.success(message, {
    toastId: message,
    position: "top-right",
    autoClose,
    theme: "colored",
    transition,
  });
};

export const showPrimaryNotification = (message: string) => {
  toast(message, {
    toastId: message,
    position: "top-right",
    hideProgressBar: true,
    autoClose,
    style: {
      backgroundColor: "rgb(0, 99, 211)",
      color: "white",
      fontSize: "16px",
    },
    closeButton: false,
    transition,
  });
};

export const showWeatherConfirmationNotification = (message: string) => {
  toast.info(message, {
    position: "top-right",
    hideProgressBar: true,
    autoClose,
    style: {
      backgroundColor: "rgb(0, 99, 211)",
      color: "white",
      fontSize: "16px",
    },
    transition,
  });
};

export const showWeatherErrorNotification = (message: string) => {
  toast.error(message, {
    position: "top-right",
    hideProgressBar: true,
    autoClose,
    style: {
      backgroundColor: "rgb(0, 99, 211)",
      color: "white",
      fontSize: "16px",
    },
    transition,
  });
};

export const showErrorNotification = (message: string, position?: ToastPosition) => {
  toast.error(message, {
    toastId: `${message}-${Date.now()}`,
    position: position ?? "top-right",
    theme: "colored",
    closeOnClick: true,
    autoClose,
    transition,
  });
};
